const wechat = {
    state:{
        isConfig: false,
        position:{},
        address:''
    },
    mutations:{
        complateConfig(state){
            state.isConfig = true;
        },
        setPosition(state,pos){
            state.position = pos;
        },
        setAddress(state,addr){
            state.address = addr;
        }
    },
    action:{}
};

export default wechat;